const build_path = (...args) => args.map((part, i) => {
	if (i === 0) {
		return part.trim().replace(/[\/]*$/g, '')
	} else {
		return part.trim().replace(/(^[\/]*|[\/]*$)/g, '')
	}
}).filter(x => x.length).join('/');

export default build_path;